import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useNotificationStore } from "../../store/notificationStore";

export function NotificationToast() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const toasts = useNotificationStore((s) => s.toasts);
  const dismissToast = useNotificationStore((s) => s.dismissToast);
  const toast = toasts[0];

  useEffect(() => {
    if (!toast) return;
    const timer = setTimeout(() => dismissToast(toast.id), 4000);
    return () => clearTimeout(timer);
  }, [toast, dismissToast]);

  if (!toast) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      data-testid="notification-toast"
      onClick={() => {
        dismissToast(toast.id);
        navigate(toast.navigateTo);
      }}
      style={{
        position: "fixed",
        bottom: 72,
        right: 16,
        zIndex: 3000,
        cursor: "pointer",
        background: "var(--bg-elevated)",
        borderLeft: "3px solid var(--primary-text)",
        borderRadius: 8,
        padding: "10px 14px",
        display: "flex",
        alignItems: "center",
        gap: 10,
        boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        maxWidth: 280,
        minWidth: 200,
      }}
    >
      <div
        aria-hidden
        style={{
          width: 36,
          height: 36,
          background: "var(--primary)",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: 700,
          color: "white",
          flexShrink: 0,
          fontSize: 14,
        }}
      >
        {toast.senderName[0]?.toUpperCase() ?? "?"}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{ fontSize: 13, fontWeight: 600, color: "var(--foreground)" }}
        >
          {toast.senderName}
        </div>
        <div
          style={{
            fontSize: 12,
            color: "var(--foreground-subtle)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {toast.count > 1
            ? t("notif_new_messages", { count: toast.count })
            : toast.text}
        </div>
      </div>
    </div>
  );
}

export default NotificationToast;
